enum Currency {
  Kuna = 1,
  Euro = 2,
  Dollar
}

export default Currency;
